import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ContactDetailsCRProps = { tableProps: TableProps<any> };

export const ContactDetailsCR = ({ tableProps }: ContactDetailsCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
